import type { ApolloError } from '@apollo/client';

const FORBIDDEN_STATUS_CODE = 403;
const INSUFFICIENT_PERMISSION_MESSAGE = 'insufficient permission';

const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null;
};

const hasForbiddenStatus = (value: unknown): boolean => {
  if (!isObject(value)) {
    return false;
  }

  if (value.statusCode === FORBIDDEN_STATUS_CODE || value.status === FORBIDDEN_STATUS_CODE) {
    return true;
  }

  if (isObject(value.response)) {
    return hasForbiddenStatus(value.response);
  }

  return false;
};

/**
 * Returns true when an Apollo error represents a permission-denied GraphQL request.
 */
export const isGraphqlPermissionError = (error?: ApolloError): boolean => {
  if (!error) {
    return false;
  }

  if (hasForbiddenStatus(error.networkError)) {
    return true;
  }

  return error.graphQLErrors.some((graphQLError) => {
    return graphQLError.message.includes(INSUFFICIENT_PERMISSION_MESSAGE);
  });
};
